import React, { useRef } from 'react';
import { useState } from 'react';
import { 
  StyledConfigShirtWrap,
  StyledConfigShirtCols,
  StyledConfigShirtRow
} from './StyledConfigShirt';

const ConfigShirt = () => {
  const wrapper = useRef(null);
  const [indexSlide,setIndexSlide] = useState(0);

  const configSlide = (dir) =>{
    let newIndex = indexSlide + dir < 0 ? 0 
                  : indexSlide + dir > 2 ? 2 
                  : indexSlide + dir;
    setIndexSlide(newIndex)
  }
  const iframeAction = (action, e) => {
    
    const currentTarget = e.currentTarget;
    const selected = currentTarget.parentNode.querySelector('.selected');
    if(selected) selected.classList.remove('selected');
    currentTarget.classList.add('selected')
    wrapper.current.querySelector('iframe').contentWindow.postMessage(action, '*');
  }
  const handleWinScroll = (isEnter) => {
    document.querySelector('body').style.overflow = isEnter ? 'hidden' : 'scroll';
  }
  return (
    <React.Fragment>
      <StyledConfigShirtWrap>
        <h4 className="md--title">Product Configurator</h4>
        
        <StyledConfigShirtCols ref={wrapper} >
          <iframe id="shirt" src="/shirt/index.html" onMouseEnter={() => handleWinScroll(true)} onMouseLeave={() => handleWinScroll(false)} />
          <div className="col-config col-buttons hide-tablet hide-mobile">
            <div className="row-config ">
              <p className="preset-11">
                Select the shirt collar
              </p>
              <div className="icons-row">
                <div className="icon-wrap" onClick={(e) => iframeAction('setCol1', e)}>
                  <img src={require('../../assets/3dexperience/botton-1.png')} />
                  <p className="">
                    Classic
                  </p>
                </div>
                <div className="icon-wrap" onClick={(e) => iframeAction('setCol2', e)}>
                  <img src={require('../../assets/3dexperience/botton-2.png')} />
                  <p className="">
                    Button Down
                  </p>
                </div>
              </div>
            </div>
            <div className="row-config">
              <p className="preset-11">
                Select the cuff
              </p>
              <div className="icons-row" >
                <div className="icon-wrap" onClick={(e) => iframeAction('setPol1', e)}>
                  <img src={require('../../assets/3dexperience/botton-3.png')} />
                  <p className="">
                    Squared
                  </p>
                </div>
                <div className="icon-wrap" onClick={(e) => iframeAction('setPol2', e)}>
                  <img src={require('../../assets/3dexperience/botton-4.png')} />
                  <p className="">
                    Angled
                  </p>
                </div>
              </div>
            </div>
            <div className="row-config">
              <p className="preset-11">
                Select the fabric
              </p>
              <div className="icons-row" >
                <div className="icon-wrap" onClick={(e) => iframeAction('setMat1', e)}>
                  <img src={require('../../assets/3dexperience/botton-5.png')} />
                  <p className="">
                    Vertical Blue
                  </p>
                </div>
                <div className="icon-wrap" onClick={(e) => iframeAction('setMat2', e)}>
                  <img src={require('../../assets/3dexperience/botton-6.png')} />
                  <p className="">
                    Sky Grey
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-config-mobile col-buttons hide-desktop">
            <div className="col-config-slide" style={{transform: `translateX(-${indexSlide * 100}%)`}}>
              <div className="row-config-mobile ">
                <p className="preset-11">
                  Select the shirt collar
                </p>
                <div className="icons-row">
                  <div className="icon-wrap" onClick={(e) => iframeAction('setCol1', e)}>
                    <img src={require('../../assets/3dexperience/botton-1.png')} />
                  </div>
                  <div className="icon-wrap" onClick={(e) => iframeAction('setCol2', e)}>
                    <img src={require('../../assets/3dexperience/botton-2.png')} />
                  </div>
                </div>
              </div>
              <div className="row-config-mobile">
                <p className="preset-11">
                  Select the cuff
                </p>
                <div className="icons-row" >
                  <div className="icon-wrap" onClick={(e) => iframeAction('setPol1', e)}>
                    <img src={require('../../assets/3dexperience/botton-3.png')} />
                  </div>
                  <div className="icon-wrap" onClick={(e) => iframeAction('setPol2', e)}>
                    <img src={require('../../assets/3dexperience/botton-4.png')} />
                  </div>
                </div>
              </div>
              <div className="row-config-mobile">
                <p className="preset-11">
                  Select the fabric
                </p>
                <div className="icons-row" >
                  <div className="icon-wrap" onClick={(e) => iframeAction('setMat1', e)}>
                    <img src={require('../../assets/3dexperience/botton-5.png')} />
                    
                  </div>
                  <div className="icon-wrap" onClick={(e) => iframeAction('setMat2', e)}>
                    <img src={require('../../assets/3dexperience/botton-6.png')} />
                  </div>
                </div>
              </div>
            </div>
            <div className={ indexSlide > 0 ? "arrow-config arrow-prev" : "arrow-config arrow-prev disable"} onClick={() => configSlide(-1)}>
              <img src={require('../../assets/arrow-circle-prev.png')} />
            </div>
            <div className={ indexSlide < 2 ? "arrow-config arrow-next" :"arrow-config arrow-next disable"} onClick={() => configSlide(1)}>
              <img src={require('../../assets/arrow-circle-next.png')} />
            </div>
          </div>
          <div className="col-config">
            <div className="col-row-text">
              <p className="preset-11 blue"><b>Man shirt*</b></p>
            </div>
            <div className="col-row-text">
              <p className="preset-11 grey-400">
              We want to get fashion ready for a high-bandwidth world. Our high-quality solutions make it possible to visualize in a detailed way every object that you are buying.
              </p>
            </div>
            <div className="col-row-text">
              <p className="preset-11 blue"><em>*3D made for REDA1865</em></p>
            </div>
            <div className="col-row-text">
              <img src={require('../../assets/3dexperience/col-detail-camicia@2x.png')} />
            </div>
          </div>
        </StyledConfigShirtCols>
        <StyledConfigShirtRow>
          <img className="wash" src={require('../../assets/3dexperience/wash@2x.jpg')} />
          <img className="rewiews" src={require('../../assets/3dexperience/reviews@2x.png')} />
          <img className="stars" src={require('../../assets/3dexperience/stars@2x.png')} />
        </StyledConfigShirtRow>
      </StyledConfigShirtWrap>
    </React.Fragment>
  )
}

export default ConfigShirt;